import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'
import { volcanoReelSetting } from 'settings/custom/reels'

export default class VolcanReelsEntity extends PIXI.Container {
  constructor() {
    super()
    this.reels = []
    this.cometeContainer //todo extract from reel

    signal.on('VolcanReelsEntity:START', () => signal.once('ACTION:REEL-SPIN', () => this.start()))//todo ?????
    signal.on('VolcanReelsEntity:REFRESH', this.refresh.bind(this))
  }
  refresh() {
    this.reels.forEach((reel) => reel.refresh())
  }

  async start() {
    signal.dispatch('REELS-START')
    signal.once(`END-STOP-REEL|${this.reels.length - 1}`, () => signal.dispatch('REELS-STOP'))
    this.reels.forEach((reel, index) => {
      const delay = volcanoReelSetting[game.models.ModeModel.turbo].reelfsDelay
      gsap.delayedCall(delay * index, () => reel.start(this.cometeContainer))
    })
  }

  register = (type, object) => {
    if (type === 'VolcanReel') {
      this.reels.push(object)
    }
    else if (type === 'VolcanComete') {
      this.cometeContainer = object
    }
  }
}
